import { useEffect, useState } from 'react';

/**
 * Current time in ms, refreshed every `intervalMs`. For time-relative UI that
 * must expire on its own (the "Live" dot, an elapsed takeover or reply window).
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}

export default useNow;
